/**
 * LinkedIn Industry Codes V2 labels (deduplicated, alphabetical).
 * Source: https://github.com/HarvestAPI/linkedin-industry-codes-v2
 */
export const linkedinIndustryOptions = [
	{ value: "Abrasives and Nonmetallic Minerals Manufacturing", label: "Abrasives and Nonmetallic Minerals Manufacturing" },
	{ value: "Accessible Architecture and Design", label: "Accessible Architecture and Design" },
	{ value: "Accessible Hardware Manufacturing", label: "Accessible Hardware Manufacturing" },
	{ value: "Accommodation Services", label: "Accommodation Services" },
	{ value: "Accounting", label: "Accounting" },
	{ value: "Administration of Justice", label: "Administration of Justice" },
	{ value: "Administrative and Support Services", label: "Administrative and Support Services" },
	{ value: "Advertising Services", label: "Advertising Services" },
	{ value: "Agricultural Chemical Manufacturing", label: "Agricultural Chemical Manufacturing" },
	{ value: "Agriculture, Construction, Mining Machinery Manufacturing", label: "Agriculture, Construction, Mining Machinery Manufacturing" },
	{ value: "Air, Water, and Waste Program Management", label: "Air, Water, and Waste Program Management" },
	{ value: "Airlines and Aviation", label: "Airlines and Aviation" },
	{ value: "Alternative Dispute Resolution", label: "Alternative Dispute Resolution" },
	{ value: "Alternative Fuel Vehicle Manufacturing", label: "Alternative Fuel Vehicle Manufacturing" },
	{ value: "Alternative Medicine", label: "Alternative Medicine" },
	{ value: "Ambulance Services", label: "Ambulance Services" },
	{ value: "Amusement Parks and Arcades", label: "Amusement Parks and Arcades" },
	{ value: "Animal Feed Manufacturing", label: "Animal Feed Manufacturing" },
	{ value: "Animation and Post-production", label: "Animation and Post-production" },
	{ value: "Apparel Manufacturing", label: "Apparel Manufacturing" },
	{ value: "Appliances, Electrical, and Electronics Manufacturing", label: "Appliances, Electrical, and Electronics Manufacturing" },
	{ value: "Architectural and Structural Metal Manufacturing", label: "Architectural and Structural Metal Manufacturing" },
	{ value: "Architecture and Planning", label: "Architecture and Planning" },
	{ value: "Armed Forces", label: "Armed Forces" },
	{ value: "Artificial Rubber and Synthetic Fiber Manufacturing", label: "Artificial Rubber and Synthetic Fiber Manufacturing" },
	{ value: "Artists and Writers", label: "Artists and Writers" },
	{ value: "Audio and Video Equipment Manufacturing", label: "Audio and Video Equipment Manufacturing" },
	{ value: "Automation Machinery Manufacturing", label: "Automation Machinery Manufacturing" },
	{ value: "Aviation and Aerospace Component Manufacturing", label: "Aviation and Aerospace Component Manufacturing" },
	{ value: "Baked Goods Manufacturing", label: "Baked Goods Manufacturing" },
	{ value: "Banking", label: "Banking" },
	{ value: "Bars, Taverns, and Nightclubs", label: "Bars, Taverns, and Nightclubs" },
	{ value: "Bed-and-Breakfasts, Hostels, Homestays", label: "Bed-and-Breakfasts, Hostels, Homestays" },
	{ value: "Beverage Manufacturing", label: "Beverage Manufacturing" },
	{ value: "Biomass Electric Power Generation", label: "Biomass Electric Power Generation" },
	{ value: "Biotechnology Research", label: "Biotechnology Research" },
	{ value: "Blockchain Services", label: "Blockchain Services" },
	{ value: "Blogs", label: "Blogs" },
	{ value: "Boilers, Tanks, and Shipping Container Manufacturing", label: "Boilers, Tanks, and Shipping Container Manufacturing" },
	{ value: "Book and Periodical Publishing", label: "Book and Periodical Publishing" },
	{ value: "Book Publishing", label: "Book Publishing" },
	{ value: "Breweries", label: "Breweries" },
	{ value: "Broadcast Media Production and Distribution", label: "Broadcast Media Production and Distribution" },
	{ value: "Building Construction", label: "Building Construction" },
	{ value: "Building Equipment Contractors", label: "Building Equipment Contractors" },
	{ value: "Building Finishing Contractors", label: "Building Finishing Contractors" },
	{ value: "Building Structure and Exterior Contractors", label: "Building Structure and Exterior Contractors" },
	{ value: "Business Consulting and Services", label: "Business Consulting and Services" },
	{ value: "Business Content", label: "Business Content" },
	{ value: "Business Intelligence Platforms", label: "Business Intelligence Platforms" },
	{ value: "Cable and Satellite Programming", label: "Cable and Satellite Programming" },
	{ value: "Capital Markets", label: "Capital Markets" },
	{ value: "Caterers", label: "Caterers" },
	{ value: "Chemical Manufacturing", label: "Chemical Manufacturing" },
	{ value: "Chemical Raw Materials Manufacturing", label: "Chemical Raw Materials Manufacturing" },
	{ value: "Child Day Care Services", label: "Child Day Care Services" },
	{ value: "Chiropractors", label: "Chiropractors" },
	{ value: "Circuses and Magic Shows", label: "Circuses and Magic Shows" },
	{ value: "Civic and Social Organizations", label: "Civic and Social Organizations" },
	{ value: "Civil Engineering", label: "Civil Engineering" },
	{ value: "Claims Adjusting, Actuarial Services", label: "Claims Adjusting, Actuarial Services" },
	{ value: "Clay and Refractory Products Manufacturing", label: "Clay and Refractory Products Manufacturing" },
	{ value: "Climate Data and Analytics", label: "Climate Data and Analytics" },
	{ value: "Climate Technology Product Manufacturing", label: "Climate Technology Product Manufacturing" },
	{ value: "Coal Mining", label: "Coal Mining" },
	{ value: "Collection Agencies", label: "Collection Agencies" },
	{ value: "Commercial and Industrial Equipment Rental", label: "Commercial and Industrial Equipment Rental" },
	{ value: "Commercial and Industrial Machinery Maintenance", label: "Commercial and Industrial Machinery Maintenance" },
	{ value: "Commercial and Service Industry Machinery Manufacturing", label: "Commercial and Service Industry Machinery Manufacturing" },
	{ value: "Communications Equipment Manufacturing", label: "Communications Equipment Manufacturing" },
	{ value: "Community Development and Urban Planning", label: "Community Development and Urban Planning" },
	{ value: "Community Services", label: "Community Services" },
	{ value: "Computer and Network Security", label: "Computer and Network Security" },
	{ value: "Computer Games", label: "Computer Games" },
	{ value: "Computer Hardware Manufacturing", label: "Computer Hardware Manufacturing" },
	{ value: "Computer Networking Products", label: "Computer Networking Products" },
	{ value: "Computers and Electronics Manufacturing", label: "Computers and Electronics Manufacturing" },
	{ value: "Conservation Programs", label: "Conservation Programs" },
	{ value: "Construction", label: "Construction" },
	{ value: "Construction Hardware Manufacturing", label: "Construction Hardware Manufacturing" },
	{ value: "Consumer Goods Rental", label: "Consumer Goods Rental" },
	{ value: "Consumer Services", label: "Consumer Services" },
	{ value: "Correctional Institutions", label: "Correctional Institutions" },
	{ value: "Cosmetology and Barber Schools", label: "Cosmetology and Barber Schools" },
	{ value: "Courts of Law", label: "Courts of Law" },
	{ value: "Credit Intermediation", label: "Credit Intermediation" },
	{ value: "Cutlery and Handtool Manufacturing", label: "Cutlery and Handtool Manufacturing" },
	{ value: "Dairy Product Manufacturing", label: "Dairy Product Manufacturing" },
	{ value: "Dance Companies", label: "Dance Companies" },
	{ value: "Data Infrastructure and Analytics", label: "Data Infrastructure and Analytics" },
	{ value: "Data Security Software Products", label: "Data Security Software Products" },
	{ value: "Defense and Space Manufacturing", label: "Defense and Space Manufacturing" },
	{ value: "Dentists", label: "Dentists" },
	{ value: "Design Services", label: "Design Services" },
	{ value: "Desktop Computing Software Products", label: "Desktop Computing Software Products" },
	{ value: "Digital Accessibility Services", label: "Digital Accessibility Services" },
	{ value: "Distilleries", label: "Distilleries" },
	{ value: "E-Learning Providers", label: "E-Learning Providers" },
	{ value: "Economic Programs", label: "Economic Programs" },
	{ value: "Education", label: "Education" },
	{ value: "Education Administration Programs", label: "Education Administration Programs" },
	{ value: "Electric Lighting Equipment Manufacturing", label: "Electric Lighting Equipment Manufacturing" },
	{ value: "Electric Power Generation", label: "Electric Power Generation" },
	{ value: "Electric Power Transmission, Control, and Distribution", label: "Electric Power Transmission, Control, and Distribution" },
	{ value: "Electrical Equipment Manufacturing", label: "Electrical Equipment Manufacturing" },
	{ value: "Electronic and Precision Equipment Maintenance", label: "Electronic and Precision Equipment Maintenance" },
	{ value: "Embedded Software Products", label: "Embedded Software Products" },
	{ value: "Emergency and Relief Services", label: "Emergency and Relief Services" },
	{ value: "Engineering Services", label: "Engineering Services" },
	{ value: "Engines and Power Transmission Equipment Manufacturing", label: "Engines and Power Transmission Equipment Manufacturing" },
	{ value: "Entertainment Providers", label: "Entertainment Providers" },
	{ value: "Environmental Quality Programs", label: "Environmental Quality Programs" },
	{ value: "Environmental Services", label: "Environmental Services" },
	{ value: "Equipment Rental Services", label: "Equipment Rental Services" },
	{ value: "Events Services", label: "Events Services" },
	{ value: "Executive Offices", label: "Executive Offices" },
	{ value: "Executive Search Services", label: "Executive Search Services" },
	{ value: "Fabricated Metal Products", label: "Fabricated Metal Products" },
	{ value: "Facilities Services", label: "Facilities Services" },
	{ value: "Family Planning Centers", label: "Family Planning Centers" },
	{ value: "Farming", label: "Farming" },
	{ value: "Farming, Ranching, Forestry", label: "Farming, Ranching, Forestry" },
	{ value: "Fashion Accessories Manufacturing", label: "Fashion Accessories Manufacturing" },
	{ value: "Financial Services", label: "Financial Services" },
	{ value: "Fine Arts Schools", label: "Fine Arts Schools" },
	{ value: "Fire Protection", label: "Fire Protection" },
	{ value: "Fisheries", label: "Fisheries" },
	{ value: "Flight Training", label: "Flight Training" },
	{ value: "Food and Beverage Manufacturing", label: "Food and Beverage Manufacturing" },
	{ value: "Food and Beverage Retail", label: "Food and Beverage Retail" },
	{ value: "Food and Beverage Services", label: "Food and Beverage Services" },
	{ value: "Footwear and Leather Goods Repair", label: "Footwear and Leather Goods Repair" },
	{ value: "Footwear Manufacturing", label: "Footwear Manufacturing" },
	{ value: "Forestry and Logging", label: "Forestry and Logging" },
	{ value: "Fossil Fuel Electric Power Generation", label: "Fossil Fuel Electric Power Generation" },
	{ value: "Freight and Package Transportation", label: "Freight and Package Transportation" },
	{ value: "Fruit and Vegetable Preserves Manufacturing", label: "Fruit and Vegetable Preserves Manufacturing" },
	{ value: "Fuel Cell Manufacturing", label: "Fuel Cell Manufacturing" },
	{ value: "Fundraising", label: "Fundraising" },
	{ value: "Funds and Trusts", label: "Funds and Trusts" },
	{ value: "Furniture and Home Furnishings Manufacturing", label: "Furniture and Home Furnishings Manufacturing" },
	{ value: "Gambling Facilities and Casinos", label: "Gambling Facilities and Casinos" },
	{ value: "Geothermal Electric Power Generation", label: "Geothermal Electric Power Generation" },
	{ value: "Glass Product Manufacturing", label: "Glass Product Manufacturing" },
	{ value: "Glass, Ceramics and Concrete Manufacturing", label: "Glass, Ceramics and Concrete Manufacturing" },
	{ value: "Golf Courses and Country Clubs", label: "Golf Courses and Country Clubs" },
	{ value: "Government Administration", label: "Government Administration" },
	{ value: "Government Relations Services", label: "Government Relations Services" },
	{ value: "Graphic Design", label: "Graphic Design" },
	{ value: "Ground Passenger Transportation", label: "Ground Passenger Transportation" },
	{ value: "Health and Human Services", label: "Health and Human Services" },
	{ value: "Higher Education", label: "Higher Education" },
	{ value: "Highway, Street, and Bridge Construction", label: "Highway, Street, and Bridge Construction" },
	{ value: "Historical Sites", label: "Historical Sites" },
	{ value: "Holding Companies", label: "Holding Companies" },
	{ value: "Home Health Care Services", label: "Home Health Care Services" },
	{ value: "Horticulture", label: "Horticulture" },
	{ value: "Hospitality", label: "Hospitality" },
	{ value: "Hospitals", label: "Hospitals" },
	{ value: "Hospitals and Health Care", label: "Hospitals and Health Care" },
	{ value: "Hotels and Motels", label: "Hotels and Motels" },
	{ value: "Household and Institutional Furniture Manufacturing", label: "Household and Institutional Furniture Manufacturing" },
	{ value: "Household Appliance Manufacturing", label: "Household Appliance Manufacturing" },
	{ value: "Household Services", label: "Household Services" },
	{ value: "Housing and Community Development", label: "Housing and Community Development" },
	{ value: "Housing Programs", label: "Housing Programs" },
	{ value: "Human Resources Services", label: "Human Resources Services" },
	{ value: "HVAC and Refrigeration Equipment Manufacturing", label: "HVAC and Refrigeration Equipment Manufacturing" },
	{ value: "Hydroelectric Power Generation", label: "Hydroelectric Power Generation" },
	{ value: "Individual and Family Services", label: "Individual and Family Services" },
	{ value: "Industrial Machinery Manufacturing", label: "Industrial Machinery Manufacturing" },
	{ value: "Industry Associations", label: "Industry Associations" },
	{ value: "Information Services", label: "Information Services" },
	{ value: "Insurance", label: "Insurance" },
	{ value: "Insurance Agencies and Brokerages", label: "Insurance Agencies and Brokerages" },
	{ value: "Insurance and Employee Benefit Funds", label: "Insurance and Employee Benefit Funds" },
	{ value: "Insurance Carriers", label: "Insurance Carriers" },
	{ value: "Interior Design", label: "Interior Design" },
	{ value: "International Affairs", label: "International Affairs" },
	{ value: "International Trade and Development", label: "International Trade and Development" },
	{ value: "Internet Marketplace Platforms", label: "Internet Marketplace Platforms" },
	{ value: "Internet News", label: "Internet News" },
	{ value: "Internet Publishing", label: "Internet Publishing" },
	{ value: "Interurban and Rural Bus Services", label: "Interurban and Rural Bus Services" },
	{ value: "Investment Advice", label: "Investment Advice" },
	{ value: "Investment Banking", label: "Investment Banking" },
	{ value: "Investment Management", label: "Investment Management" },
	{ value: "IT Services and IT Consulting", label: "IT Services and IT Consulting" },
	{ value: "IT System Custom Software Development", label: "IT System Custom Software Development" },
	{ value: "IT System Data Services", label: "IT System Data Services" },
	{ value: "IT System Design Services", label: "IT System Design Services" },
	{ value: "IT System Installation and Disposal", label: "IT System Installation and Disposal" },
	{ value: "IT System Operations and Maintenance", label: "IT System Operations and Maintenance" },
	{ value: "IT System Testing and Evaluation", label: "IT System Testing and Evaluation" },
	{ value: "IT System Training and Support", label: "IT System Training and Support" },
	{ value: "Janitorial Services", label: "Janitorial Services" },
	{ value: "Landscaping Services", label: "Landscaping Services" },
	{ value: "Language Schools", label: "Language Schools" },
	{ value: "Laundry and Drycleaning Services", label: "Laundry and Drycleaning Services" },
	{ value: "Law Enforcement", label: "Law Enforcement" },
	{ value: "Law Practice", label: "Law Practice" },
	{ value: "Leasing Non-residential Real Estate", label: "Leasing Non-residential Real Estate" },
	{ value: "Leasing Residential Real Estate", label: "Leasing Residential Real Estate" },
	{ value: "Leather Product Manufacturing", label: "Leather Product Manufacturing" },
	{ value: "Legal Services", label: "Legal Services" },
	{ value: "Legislative Offices", label: "Legislative Offices" },
	{ value: "Libraries", label: "Libraries" },
	{ value: "Lime and Gypsum Products Manufacturing", label: "Lime and Gypsum Products Manufacturing" },
	{ value: "Loan Brokers", label: "Loan Brokers" },
	{ value: "Machinery Manufacturing", label: "Machinery Manufacturing" },
	{ value: "Magnetic and Optical Media Manufacturing", label: "Magnetic and Optical Media Manufacturing" },
	{ value: "Manufacturing", label: "Manufacturing" },
	{ value: "Maritime Transportation", label: "Maritime Transportation" },
	{ value: "Market Research", label: "Market Research" },
	{ value: "Marketing Services", label: "Marketing Services" },
	{ value: "Mattress and Blinds Manufacturing", label: "Mattress and Blinds Manufacturing" },
	{ value: "Measuring and Control Instrument Manufacturing", label: "Measuring and Control Instrument Manufacturing" },
	{ value: "Meat Products Manufacturing", label: "Meat Products Manufacturing" },
	{ value: "Media & Telecommunications", label: "Media & Telecommunications" },
	{ value: "Media Production", label: "Media Production" },
	{ value: "Medical and Diagnostic Laboratories", label: "Medical and Diagnostic Laboratories" },
	{ value: "Medical Equipment Manufacturing", label: "Medical Equipment Manufacturing" },
	{ value: "Medical Practices", label: "Medical Practices" },
	{ value: "Mental Health Care", label: "Mental Health Care" },
	{ value: "Metal Ore Mining", label: "Metal Ore Mining" },
	{ value: "Metal Treatments", label: "Metal Treatments" },
	{ value: "Metal Valve, Ball, and Roller Manufacturing", label: "Metal Valve, Ball, and Roller Manufacturing" },
	{ value: "Metalworking Machinery Manufacturing", label: "Metalworking Machinery Manufacturing" },
	{ value: "Military and International Affairs", label: "Military and International Affairs" },
	{ value: "Mining", label: "Mining" },
	{ value: "Mobile Computing Software Products", label: "Mobile Computing Software Products" },
	{ value: "Mobile Food Services", label: "Mobile Food Services" },
	{ value: "Mobile Gaming Apps", label: "Mobile Gaming Apps" },
	{ value: "Motor Vehicle Manufacturing", label: "Motor Vehicle Manufacturing" },
	{ value: "Motor Vehicle Parts Manufacturing", label: "Motor Vehicle Parts Manufacturing" },
	{ value: "Movies and Sound Recording", label: "Movies and Sound Recording" },
	{ value: "Movies, Videos and Sound", label: "Movies, Videos and Sound" },
	{ value: "Museums", label: "Museums" },
	{ value: "Museums, Historical Sites, and Zoos", label: "Museums, Historical Sites, and Zoos" },
	{ value: "Musicians", label: "Musicians" },
	{ value: "Nanotechnology Research", label: "Nanotechnology Research" },
	{ value: "Natural Gas Distribution", label: "Natural Gas Distribution" },
	{ value: "Natural Gas Extraction", label: "Natural Gas Extraction" },
	{ value: "Newspaper Publishing", label: "Newspaper Publishing" },
	{ value: "Non-profit Organizations", label: "Non-profit Organizations" },
	{ value: "Nonmetallic Mineral Mining", label: "Nonmetallic Mineral Mining" },
	{ value: "Nonresidential Building Construction", label: "Nonresidential Building Construction" },
	{ value: "Nuclear Electric Power Generation", label: "Nuclear Electric Power Generation" },
	{ value: "Nursing Homes and Residential Care Facilities", label: "Nursing Homes and Residential Care Facilities" },
	{ value: "Office Administration", label: "Office Administration" },
	{ value: "Office Furniture and Fixtures Manufacturing", label: "Office Furniture and Fixtures Manufacturing" },
	{ value: "Oil and Coal Product Manufacturing", label: "Oil and Coal Product Manufacturing" },
	{ value: "Oil and Gas", label: "Oil and Gas" },
	{ value: "Oil Extraction", label: "Oil Extraction" },
	{ value: "Oil, Gas, and Mining", label: "Oil, Gas, and Mining" },
	{ value: "Online and Mail Order Retail", label: "Online and Mail Order Retail" },
	{ value: "Online Audio and Video Media", label: "Online Audio and Video Media" },
	{ value: "Operations Consulting", label: "Operations Consulting" },
	{ value: "Optometrists", label: "Optometrists" },
	{ value: "Outpatient Care Centers", label: "Outpatient Care Centers" },
	{ value: "Outsourcing and Offshoring Consulting", label: "Outsourcing and Offshoring Consulting" },
	{ value: "Packaging and Containers Manufacturing", label: "Packaging and Containers Manufacturing" },
	{ value: "Paint, Coating, and Adhesive Manufacturing", label: "Paint, Coating, and Adhesive Manufacturing" },
	{ value: "Paper and Forest Product Manufacturing", label: "Paper and Forest Product Manufacturing" },
	{ value: "Pension Funds", label: "Pension Funds" },
	{ value: "Performing Arts", label: "Performing Arts" },
	{ value: "Performing Arts and Spectator Sports", label: "Performing Arts and Spectator Sports" },
	{ value: "Periodical Publishing", label: "Periodical Publishing" },
	{ value: "Personal and Laundry Services", label: "Personal and Laundry Services" },
	{ value: "Personal Care Product Manufacturing", label: "Personal Care Product Manufacturing" },
	{ value: "Personal Care Services", label: "Personal Care Services" },
	{ value: "Pet Services", label: "Pet Services" },
	{ value: "Pharmaceutical Manufacturing", label: "Pharmaceutical Manufacturing" },
	{ value: "Philanthropic Fundraising Services", label: "Philanthropic Fundraising Services" },
	{ value: "Photography", label: "Photography" },
	{ value: "Physical, Occupational and Speech Therapists", label: "Physical, Occupational and Speech Therapists" },
	{ value: "Physicians", label: "Physicians" },
	{ value: "Pipeline Transportation", label: "Pipeline Transportation" },
	{ value: "Plastics and Rubber Product Manufacturing", label: "Plastics and Rubber Product Manufacturing" },
	{ value: "Plastics Manufacturing", label: "Plastics Manufacturing" },
	{ value: "Political Organizations", label: "Political Organizations" },
	{ value: "Postal Services", label: "Postal Services" },
	{ value: "Primary and Secondary Education", label: "Primary and Secondary Education" },
	{ value: "Primary Metal Manufacturing", label: "Primary Metal Manufacturing" },
	{ value: "Printing Services", label: "Printing Services" },
	{ value: "Professional Organizations", label: "Professional Organizations" },
	{ value: "Professional Services", label: "Professional Services" },
	{ value: "Professional Training and Coaching", label: "Professional Training and Coaching" },
	{ value: "Public Assistance Programs", label: "Public Assistance Programs" },
	{ value: "Public Health", label: "Public Health" },
	{ value: "Public Policy Offices", label: "Public Policy Offices" },
	{ value: "Public Relations and Communications Services", label: "Public Relations and Communications Services" },
	{ value: "Public Safety", label: "Public Safety" },
	{ value: "Racetracks", label: "Racetracks" },
	{ value: "Radio and Television Broadcasting", label: "Radio and Television Broadcasting" },
	{ value: "Rail Transportation", label: "Rail Transportation" },
	{ value: "Railroad Equipment Manufacturing", label: "Railroad Equipment Manufacturing" },
	{ value: "Ranching", label: "Ranching" },
	{ value: "Ranching and Fisheries", label: "Ranching and Fisheries" },
	{ value: "Real Estate", label: "Real Estate" },
	{ value: "Real Estate Agents and Brokers", label: "Real Estate Agents and Brokers" },
	{ value: "Real Estate and Equipment Rental Services", label: "Real Estate and Equipment Rental Services" },
	{ value: "Recreational Facilities", label: "Recreational Facilities" },
	{ value: "Regenerative Design", label: "Regenerative Design" },
	{ value: "Religious Institutions", label: "Religious Institutions" },
	{ value: "Renewable Energy Equipment Manufacturing", label: "Renewable Energy Equipment Manufacturing" },
	{ value: "Renewable Energy Power Generation", label: "Renewable Energy Power Generation" },
	{ value: "Renewable Energy Semiconductor Manufacturing", label: "Renewable Energy Semiconductor Manufacturing" },
	{ value: "Repair and Maintenance", label: "Repair and Maintenance" },
	{ value: "Research Services", label: "Research Services" },
	{ value: "Residential Building Construction", label: "Residential Building Construction" },
	{ value: "Restaurants", label: "Restaurants" },
	{ value: "Retail", label: "Retail" },
	{ value: "Retail Apparel and Fashion", label: "Retail Apparel and Fashion" },
	{ value: "Retail Appliances, Electrical, and Electronic Equipment", label: "Retail Appliances, Electrical, and Electronic Equipment" },
	{ value: "Retail Art Dealers", label: "Retail Art Dealers" },
	{ value: "Retail Art Supplies", label: "Retail Art Supplies" },
	{ value: "Retail Books and Printed News", label: "Retail Books and Printed News" },
	{ value: "Retail Building Materials and Garden Equipment", label: "Retail Building Materials and Garden Equipment" },
	{ value: "Retail Florists", label: "Retail Florists" },
	{ value: "Retail Furniture and Home Furnishings", label: "Retail Furniture and Home Furnishings" },
	{ value: "Retail Gasoline", label: "Retail Gasoline" },
	{ value: "Retail Groceries", label: "Retail Groceries" },
	{ value: "Retail Health and Personal Care Products", label: "Retail Health and Personal Care Products" },
	{ value: "Retail Luxury Goods and Jewelry", label: "Retail Luxury Goods and Jewelry" },
	{ value: "Retail Motor Vehicles", label: "Retail Motor Vehicles" },
	{ value: "Retail Musical Instruments", label: "Retail Musical Instruments" },
	{ value: "Retail Office Equipment", label: "Retail Office Equipment" },
	{ value: "Retail Office Supplies and Gifts", label: "Retail Office Supplies and Gifts" },
	{ value: "Retail Pharmacies", label: "Retail Pharmacies" },
	{ value: "Retail Recyclable Materials & Used Merchandise", label: "Retail Recyclable Materials & Used Merchandise" },
	{ value: "Reupholstery and Furniture Repair", label: "Reupholstery and Furniture Repair" },
	{ value: "Robot Manufacturing", label: "Robot Manufacturing" },
	{ value: "Robotics Engineering", label: "Robotics Engineering" },
	{ value: "Rubber Products Manufacturing", label: "Rubber Products Manufacturing" },
	{ value: "Satellite Telecommunications", label: "Satellite Telecommunications" },
	{ value: "Savings Institutions", label: "Savings Institutions" },
	{ value: "School and Employee Bus Services", label: "School and Employee Bus Services" },
	{ value: "Seafood Product Manufacturing", label: "Seafood Product Manufacturing" },
	{ value: "Secretarial Schools", label: "Secretarial Schools" },
	{ value: "Securities and Commodity Exchanges", label: "Securities and Commodity Exchanges" },
	{ value: "Security and Investigations", label: "Security and Investigations" },
	{ value: "Security Guards and Patrol Services", label: "Security Guards and Patrol Services" },
	{ value: "Security Systems Services", label: "Security Systems Services" },
	{ value: "Semiconductor Manufacturing", label: "Semiconductor Manufacturing" },
	{ value: "Services for Renewable Energy", label: "Services for Renewable Energy" },
	{ value: "Services for the Elderly and Disabled", label: "Services for the Elderly and Disabled" },
	{ value: "Sheet Music Publishing", label: "Sheet Music Publishing" },
	{ value: "Shipbuilding", label: "Shipbuilding" },
	{ value: "Shuttles and Special Needs Transportation Services", label: "Shuttles and Special Needs Transportation Services" },
	{ value: "Sightseeing Transportation", label: "Sightseeing Transportation" },
	{ value: "Skiing Facilities", label: "Skiing Facilities" },
	{ value: "Smart Meter Manufacturing", label: "Smart Meter Manufacturing" },
	{ value: "Soap and Cleaning Product Manufacturing", label: "Soap and Cleaning Product Manufacturing" },
	{ value: "Social Networking Platforms", label: "Social Networking Platforms" },
	{ value: "Software Development", label: "Software Development" },
	{ value: "Solar Electric Power Generation", label: "Solar Electric Power Generation" },
	{ value: "Sound Recording", label: "Sound Recording" },
	{ value: "Space Research and Technology", label: "Space Research and Technology" },
	{ value: "Specialty Trade Contractors", label: "Specialty Trade Contractors" },
	{ value: "Spectator Sports", label: "Spectator Sports" },
	{ value: "Sporting Goods Manufacturing", label: "Sporting Goods Manufacturing" },
	{ value: "Sports and Recreation Instruction", label: "Sports and Recreation Instruction" },
	{ value: "Sports Teams and Clubs", label: "Sports Teams and Clubs" },
	{ value: "Spring and Wire Product Manufacturing", label: "Spring and Wire Product Manufacturing" },
	{ value: "Staffing and Recruiting", label: "Staffing and Recruiting" },
	{ value: "Steam and Air-Conditioning Supply", label: "Steam and Air-Conditioning Supply" },
	{ value: "Strategic Management Services", label: "Strategic Management Services" },
	{ value: "Subdivision of Land", label: "Subdivision of Land" },
	{ value: "Sugar and Confectionery Product Manufacturing", label: "Sugar and Confectionery Product Manufacturing" },
	{ value: "Surveying and Mapping Services", label: "Surveying and Mapping Services" },
	{ value: "Taxi and Limousine Services", label: "Taxi and Limousine Services" },
	{ value: "Technical and Vocational Training", label: "Technical and Vocational Training" },
	{ value: "Technology, Information and Internet", label: "Technology, Information and Internet" },
	{ value: "Technology, Information and Media", label: "Technology, Information and Media" },
	{ value: "Telecommunications", label: "Telecommunications" },
	{ value: "Telecommunications Carriers", label: "Telecommunications Carriers" },
	{ value: "Telephone Call Centers", label: "Telephone Call Centers" },
	{ value: "Temporary Help Services", label: "Temporary Help Services" },
	{ value: "Textile Manufacturing", label: "Textile Manufacturing" },
	{ value: "Theater Companies", label: "Theater Companies" },
	{ value: "Think Tanks", label: "Think Tanks" },
	{ value: "Tobacco Manufacturing", label: "Tobacco Manufacturing" },
	{ value: "Translation and Localization", label: "Translation and Localization" },
	{ value: "Transportation Equipment Manufacturing", label: "Transportation Equipment Manufacturing" },
	{ value: "Transportation Programs", label: "Transportation Programs" },
	{ value: "Transportation, Logistics, Supply Chain and Storage", label: "Transportation, Logistics, Supply Chain and Storage" },
	{ value: "Travel Arrangements", label: "Travel Arrangements" },
	{ value: "Truck Transportation", label: "Truck Transportation" },
	{ value: "Trusts and Estates", label: "Trusts and Estates" },
	{ value: "Turned Products and Fastener Manufacturing", label: "Turned Products and Fastener Manufacturing" },
	{ value: "Urban Transit Services", label: "Urban Transit Services" },
	{ value: "Utilities", label: "Utilities" },
	{ value: "Utilities Administration", label: "Utilities Administration" },
	{ value: "Utility System Construction", label: "Utility System Construction" },
	{ value: "Vehicle Repair and Maintenance", label: "Vehicle Repair and Maintenance" },
	{ value: "Venture Capital and Private Equity Principals", label: "Venture Capital and Private Equity Principals" },
	{ value: "Veterinary Services", label: "Veterinary Services" },
	{ value: "Vocational Rehabilitation Services", label: "Vocational Rehabilitation Services" },
	{ value: "Warehousing and Storage", label: "Warehousing and Storage" },
	{ value: "Waste Collection", label: "Waste Collection" },
	{ value: "Waste Treatment and Disposal", label: "Waste Treatment and Disposal" },
	{ value: "Water Supply and Irrigation Systems", label: "Water Supply and Irrigation Systems" },
	{ value: "Water, Waste, Steam, and Air Conditioning Services", label: "Water, Waste, Steam, and Air Conditioning Services" },
	{ value: "Wellness and Fitness Services", label: "Wellness and Fitness Services" },
	{ value: "Wholesale", label: "Wholesale" },
	{ value: "Wholesale Alcoholic Beverages", label: "Wholesale Alcoholic Beverages" },
	{ value: "Wholesale Apparel and Sewing Supplies", label: "Wholesale Apparel and Sewing Supplies" },
	{ value: "Wholesale Appliances, Electrical, and Electronics", label: "Wholesale Appliances, Electrical, and Electronics" },
	{ value: "Wholesale Building Materials", label: "Wholesale Building Materials" },
	{ value: "Wholesale Chemical and Allied Products", label: "Wholesale Chemical and Allied Products" },
	{ value: "Wholesale Computer Equipment", label: "Wholesale Computer Equipment" },
	{ value: "Wholesale Drugs and Sundries", label: "Wholesale Drugs and Sundries" },
	{ value: "Wholesale Food and Beverage", label: "Wholesale Food and Beverage" },
	{ value: "Wholesale Footwear", label: "Wholesale Footwear" },
	{ value: "Wholesale Furniture and Home Furnishings", label: "Wholesale Furniture and Home Furnishings" },
	{ value: "Wholesale Hardware, Plumbing, Heating Equipment", label: "Wholesale Hardware, Plumbing, Heating Equipment" },
	{ value: "Wholesale Import and Export", label: "Wholesale Import and Export" },
	{ value: "Wholesale Luxury Goods and Jewelry", label: "Wholesale Luxury Goods and Jewelry" },
	{ value: "Wholesale Machinery", label: "Wholesale Machinery" },
	{ value: "Wholesale Metals and Minerals", label: "Wholesale Metals and Minerals" },
	{ value: "Wholesale Motor Vehicles and Parts", label: "Wholesale Motor Vehicles and Parts" },
	{ value: "Wholesale Paper Products", label: "Wholesale Paper Products" },
	{ value: "Wholesale Petroleum and Petroleum Products", label: "Wholesale Petroleum and Petroleum Products" },
	{ value: "Wholesale Photography Equipment and Supplies", label: "Wholesale Photography Equipment and Supplies" },
	{ value: "Wholesale Raw Farm Products", label: "Wholesale Raw Farm Products" },
	{ value: "Wholesale Recyclable Materials", label: "Wholesale Recyclable Materials" },
	{ value: "Wind Electric Power Generation", label: "Wind Electric Power Generation" },
	{ value: "Wineries", label: "Wineries" },
	{ value: "Wireless Services", label: "Wireless Services" },
	{ value: "Women's Handbag Manufacturing", label: "Women's Handbag Manufacturing" },
	{ value: "Wood Product Manufacturing", label: "Wood Product Manufacturing" },
	{ value: "Writing and Editing", label: "Writing and Editing" },
	{ value: "Zoos and Botanical Gardens", label: "Zoos and Botanical Gardens" },
];

export default linkedinIndustryOptions;
